"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyAddressesWrapper$ = exports.PropertyAddressesWrapper$outboundSchema = exports.PropertyAddressesWrapper$inboundSchema = void 0;
exports.propertyAddressesWrapperToJSON = propertyAddressesWrapperToJSON;
exports.propertyAddressesWrapperFromJSON = propertyAddressesWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const propertyaddressesattributes_js_1 = require("./propertyaddressesattributes.js");
/** @internal */
exports.PropertyAddressesWrapper$inboundSchema = z.object({
    attributes: propertyaddressesattributes_js_1.PropertyAddressesAttributes$inboundSchema,
    id: z.string(),
    type: z.literal("property").default("property").optional(),
});
/** @internal */
exports.PropertyAddressesWrapper$outboundSchema = z.object({
    attributes: propertyaddressesattributes_js_1.PropertyAddressesAttributes$outboundSchema,
    id: z.string(),
    type: z.literal("property").default("property"),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PropertyAddressesWrapper$;
(function (PropertyAddressesWrapper$) {
    /** @deprecated use `PropertyAddressesWrapper$inboundSchema` instead. */
    PropertyAddressesWrapper$.inboundSchema = exports.PropertyAddressesWrapper$inboundSchema;
    /** @deprecated use `PropertyAddressesWrapper$outboundSchema` instead. */
    PropertyAddressesWrapper$.outboundSchema = exports.PropertyAddressesWrapper$outboundSchema;
})(PropertyAddressesWrapper$ || (exports.PropertyAddressesWrapper$ = PropertyAddressesWrapper$ = {}));
function propertyAddressesWrapperToJSON(propertyAddressesWrapper) {
    return JSON.stringify(exports.PropertyAddressesWrapper$outboundSchema.parse(propertyAddressesWrapper));
}
function propertyAddressesWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PropertyAddressesWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PropertyAddressesWrapper' from JSON`);
}
//# sourceMappingURL=propertyaddresseswrapper.js.map